import { useState } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import {
  useCustomerSelector,
  ContactUsActions,
} from '@wajeez-web/stores/customers';
import { Table, HandleTableData } from '@wajeez-web/components/data-table';
import { AdminSystemPermissions } from '@wajeez-web/core/types';
import { TextTrimmer } from '@wajeez-web/components/page-view-builder';
import { AnswerContactUsModal } from '@wajeez-web/components/modals';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { CheckBoxType } from '@wajeez-web/components/mui';

import { ContactUsTextModal } from '../components/ContactUsTextModal';
import { DataTableWrapper } from '@wajeez-web/components/helpers';

const ContactUsPage = () => {
  const [answerModalState, setAnswerModalState] = useState<{
    open: boolean;
    selected: number;
    q: string;
  }>({ open: false, selected: -1, q: '' });
  const [isTextModalOpen, setIsTextModalOpen] = useState(false);
  const [textModalContent, setTextModalContent] = useState<
    string | undefined
  >();

  const { data, status } = useCustomerSelector((state) => state.contactUs);

  const { tablePreferances, setTablePreferences, isTableReferencesLoading } =
    HandleTableData(
      'contactUs',
      ContactUsActions.contactUsDataasDataTableAsync
    );

  return (
    <div className="h-full">
      <PageLayoutsContainer
        title={`Contact Us`}
        withoutRightPadding={false}
        breadCrumbsLinks={[{ title: 'Contsct-US' }]}
      >
        <DataTableWrapper
          data={data as contentEntityDataType}
          onHeaderManage={(header) => {
            const flags = header
              ?.filter((h) => h.selected)
              .reduce(
                (previousValue: number, currentValue: CheckBoxType) =>
                  previousValue + Number(currentValue.value),
                0
              );

            tablePreferances &&
              flags &&
              setTablePreferences({
                ...tablePreferances,
                flags: flags + 1,
              });
          }}
          onPaginationChange={(pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                pageSize: pagination.pageSize,
              });
          }}
          sort={tablePreferances?.sortingOperations?.[0]}
          onSort={(sort) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                sortingOperations: [sort],
              });
          }}
          onFilter={(filters, pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                filteringOperations: filters.map((f) => {
                  return {
                    property: Number(f.key),
                    cretiria: f.value,
                    comparisonType: f.operator,
                  };
                }),
              });
          }}
          isLoading={status === 'loading'}
          columnsSelectors={(r) => {
            return {
              8: (
                <div
                  className="w-full cursor-pointer"
                  onClick={() => {
                    setTextModalContent(r[8] as string);

                    setIsTextModalOpen(true);
                  }}
                >
                  <TextTrimmer
                    key={r[1] as string}
                    textInput={r[8] as string}
                    linesNumber={2}
                  />
                </div>
              ),
            };
          }}
          preferences={tablePreferances || undefined}
          setPreferences={setTablePreferences}
        />
      </PageLayoutsContainer>
      {answerModalState.open && (
        <AnswerContactUsModal
          isOpen={answerModalState.open}
          data={{ q: answerModalState.q }}
          onClose={() =>
            setAnswerModalState({ open: false, selected: -1, q: '' })
          }
          // onSubmit={(answer) => {}}
        />
      )}
      {isTextModalOpen && (
        <ContactUsTextModal
          isOpen={isTextModalOpen}
          onClose={() => {
            setIsTextModalOpen(false);
          }}
          content={textModalContent}
        />
      )}
    </div>
  );
};

export default ContactUsPage;
